import { cx } from './cx'

/** Hexagonal counter (unread, new items). Hidden from assistive tech unless labelled. */
export function Gem({ value, gold, label, className }: { value: number | string; gold?: boolean; label?: string; className?: string }) {
  return (
    <span className={cx('gem', gold && 'gem--gold', className)} aria-label={label} aria-hidden={label ? undefined : true} role={label ? 'status' : undefined}>
      {value}
    </span>
  )
}

/** Diamond pips for step progress. */
export function Pips({ total, done, label, className }: { total: number; done: number; label?: string; className?: string }) {
  const items = Array.from({ length: Math.max(0, total) }, (_, i) => i < done)
  return (
    <span className={cx('pips', className)} role="img" aria-label={label ?? `${Math.min(done, total)} из ${total}`}>
      {items.map((on, i) => <i key={i} className={cx('pip', on && 'is-on')} />)}
    </span>
  )
}
